import axios from "axios";
import { DATA_WORKSPACE_ENABLED, legacyAnalysisPayload, WORKSPACE_SELECTION_FIELDS } from "../../config/dataWorkspaceFeature";
import { API_BASE_URL } from "../../config/api";
import { maybeEmitPermissionErrorFromAxios403 } from "../../utils/permissionAlertEmitter";
import { updateLastActivity } from "../../utils/sessionActivity";
import { persistAuthToken } from "../../utils/authTokenRefresh";
import { clearDoctorSessionStorage } from "../../utils/authSession";
import { axiosAuthDefaults } from "./axiosAuthConfig";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  ...axiosAuthDefaults,
});

axiosInstance.interceptors.request.use((config) => {
  if (!DATA_WORKSPACE_ENABLED && /\/(?:statistical-tests|stats|machine-learning)(?:\/|\?|$)/.test(config.url || "")) {
    const [path, query] = (config.url || "").split("?");
    if (query) {
      const params = new URLSearchParams(query);
      for (const key of WORKSPACE_SELECTION_FIELDS) params.delete(key);
      if (["raw", "working", "saved"].includes(params.get("mode"))) params.delete("mode");
      config.url = `${path}?${params}`;
    }
    config.data = legacyAnalysisPayload(config.data);
    config.params = legacyAnalysisPayload(config.params);
  }
  return config;
});

// Response Interceptor: Token süresi dolarsa kullanıcıyı çıkış yaptırabiliriz
axiosInstance.interceptors.response.use(
    (response) => {
      persistAuthToken(response, "token");
      if (!response.config?.url?.includes('/api/me/features')) updateLastActivity();
      return response;
    },
    (error) => {
      const url = error.config?.url || "";
      const isLoginEndpoint = url.includes("/login") || url.includes("/register") || url.includes("/verify-2fa");
      if (error.response && error.response.status === 401 && !isLoginEndpoint) {
        clearDoctorSessionStorage();
        window.location.href = "/individual-login";
      }
      maybeEmitPermissionErrorFromAxios403(error);
      return Promise.reject(error);
    }
  );

export default axiosInstance;
